// extracted by mini-css-extract-plugin
export var bubble = "_3r-0";
export var container = "_3r-f";
export var contrastBorder = "_3r-g";
export var greyOut = "_3r-2";
export var initialsColor0 = "_3r-3";
export var initialsColor1 = "_3r-4";
export var initialsColor10 = "_3r-d";
export var initialsColor11 = "_3r-e";
export var initialsColor2 = "_3r-5";
export var initialsColor3 = "_3r-6";
export var initialsColor4 = "_3r-7";
export var initialsColor5 = "_3r-8";
export var initialsColor6 = "_3r-9";
export var initialsColor7 = "_3r-a";
export var initialsColor8 = "_3r-b";
export var initialsColor9 = "_3r-c";
export var initialsWrapper = "_3r-1";
export var large = "_3r-l";
export var medium = "_3r-k";
export var mediumSmall = "_3r-j";
export var mediumSmallMedium = "_3r-o";
export var micro = "_3r-h";
export var small = "_3r-i";
export var tiny = "_3r-n";
export var xTiny = "_3r-m";